import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShareFeedbackIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 20,
	viewBox: "0 0 19 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.5 11.1875V6.4375M7.125 8.8125H11.875M5.54167 14.75V16.5989C5.54167 17.0208 5.54167 17.2317 5.62814 17.34C5.70334 17.4342 5.81738 17.4891 5.93793 17.4889C6.07654 17.4888 6.24124 17.357 6.57064 17.0935L8.45913 15.5827C8.84491 15.2741 9.0378 15.1198 9.25259 15.01C9.44316 14.9127 9.64601 14.8415 9.85563 14.7985C10.0919 14.75 10.3389 14.75 10.833 14.75H12.825C14.1551 14.75 14.8202 14.75 15.3282 14.4911C15.7751 14.2634 16.1384 13.9001 16.3661 13.4532C16.625 12.9452 16.625 12.2801 16.625 10.95V6.675C16.625 5.34488 16.625 4.67981 16.3661 4.17177C16.1384 3.72489 15.7751 3.36156 15.3282 3.13386C14.8202 2.875 14.1551 2.875 12.825 2.875H6.175C4.84488 2.875 4.17981 2.875 3.67177 3.13386C3.22489 3.36156 2.86156 3.72489 2.63386 4.17177C2.375 4.67981 2.375 5.34488 2.375 6.675V11.5833C2.375 12.3196 2.375 12.6877 2.45593 12.9897C2.67554 13.8093 3.31571 14.4495 4.1353 14.6691C4.43733 14.75 4.80544 14.75 5.54167 14.75Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShareFeedbackIcon;
